/* eslint-disable import/prefer-default-export */
import React from "react";

const styles = {
  textStyle: {
    fontWeight: "normal",
    color: "red",
    fontSize: 14,
    fontFamily: "Arial"
  }
};
export const MissedConference = props => {
  const eventName = "1-on-1 Session";
  const workerObj = props.properties.find(p => p.itemKey === "worker");
  const reasonObj = props.properties.find(p => p.itemKey === "reason");
  const outcomeObj = props.properties.find(p => p.itemKey === "outcome");
  const topicObj = props.properties.find(p => p.itemKey === "topic");

  if (!workerObj || !reasonObj || !outcomeObj || !topicObj) {
    return null;
  }

  const worker = workerObj.itemValue;
  const reason = reasonObj.itemValue;
  const outcome = outcomeObj.itemValue;
  const topic = topicObj.itemValue;

  if (worker == null || reason == null || outcome == null || topic == null) {
    return null;
  }

  return (
    <div style={{ display: "flex", justifyContent: "left" }}>
      <span style={styles.textStyle}>
        {worker} was {reason} and missed the {topic} {eventName}. The event{" "}
        {outcome}
        <br />
        <br />
      </span>
    </div>
  );
};
